import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { GestionManualComponent } from './gestion-manual/gestion-manual.component';

import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { NgSelectModule } from '@ng-select/ng-select';
import {TranslatePipe} from "@ngx-translate/core";
import { ModalFechaCorteComponent } from './modal-fecha-corte/modal-fecha-corte.component';

@NgModule({
  declarations: [GestionManualComponent, ModalFechaCorteComponent],
    imports: [
        CommonModule,
        UtilModule,
        CoreModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        AppRoutingModule,
        NgSelectModule,
        TranslatePipe
    ],
})
export class IntegradorModule {}
